import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AdsStudioBreadcrumb } from '../ads-studio-breadcrumb';

import { useBreadcrumbStyles } from './style';

export const FolderPathBreadcrumb = ({
  folderPath,
  onItemClick,
  visibleForRootFolder,
}) => {
  const items = useMemo(() => folderPath.map(item => ({
    key: item.folderId,
    text: item.folderName,
  })), [folderPath]);

  const classes = useBreadcrumbStyles();

  return (
    items.length > 1 || visibleForRootFolder ? (
      <div className={classNames('folder-path-breadcrumb', classes.breadcrumbContainer)}>
        <AdsStudioBreadcrumb
          items={items}
          onItemClick={onItemClick}
          customItemStyle={{
            breadcrumbButton: classNames('parent-folder-path', classes.breadcrumbButton),
            breadcrumbButtonCurrent: classNames('current-folder-path', classes.breadcrumbButtonCurrent),
          }}
        />
      </div>
    ) : null
  );
};

FolderPathBreadcrumb.propTypes = {
  folderPath: PropTypes.arrayOf(PropTypes.shape({
    folderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    folderName: PropTypes.string,
  })),
  onItemClick: PropTypes.func.isRequired,
  visibleForRootFolder: PropTypes.bool,
};

FolderPathBreadcrumb.defaultProps = {
  folderPath: [],
  visibleForRootFolder: false,
};
